import { OptimusPlainLink } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { Identifiable } from '@mews/std';
import { useResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { getTravelAgencyContractId } from '@mews-commander/legacy-entities/src/ducks/travelAgencyContracts';
import { getTravelAgencyName } from '@mews-commander/legacy-entities/src/ducks/travelAgencies';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { editTravelAgencyContract } from '../../actions/profile';

interface TravelAgencyLinkProps extends Identifiable {
    onClose?: () => void;
}

export const TravelAgencyLink = ({ id, onClose }: TravelAgencyLinkProps) => {
    const dispatch = useCommanderThunkDispatch();
    const resolveRoute = useResolveRoute();

    const travelAgencyName = useCommanderSelector((state) => getTravelAgencyName(state, { travelAgencyId: id }));
    const contractId = useCommanderSelector((state) => getTravelAgencyContractId(state, { companyId: id }));

    const url = contractId ? resolveRoute(RouteName.TravelAgencyContractDetail, { id: contractId }) : null;

    if (!url) {
        return <span>{UnicodeEntity.Dash}</span>;
    }

    const handleClick = () => dispatch(editTravelAgencyContract({ id, onClose }));

    return (
        <OptimusPlainLink href={url} onClick={handleClick} inherit data-test-id="travelAgencyId">
            {travelAgencyName}
        </OptimusPlainLink>
    );
};
